'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _get2 = require('lodash/get');var _get3 = _interopRequireDefault(_get2);
var _ramda = require('ramda');
var _reduxConnect = require('redux-connect');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');

var _pages = require('../../pages');
var _components = require('../../components');




var _propertyDetails = require('../../redux/modules/propertyDetails');












var _shareModal = require('../../redux/modules/shareModal');
var _favoriteProperties = require('../../redux/modules/favoriteProperties');
var _propertyNotes = require('../../redux/modules/propertyNotes');
var _reviewedPins = require('../../redux/modules/reviewedPins');
var _manageProperties = require('../../redux/modules/manageProperties');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _formatSEOData = require('../../utils/formatSEOData');
var _constants = require('../../constants');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _fetchPropertyNoteById = require('../../utils/fetchPropertyNoteById');var _fetchPropertyNoteById2 = _interopRequireDefault(_fetchPropertyNoteById);
var _services = require('../../services');

var _PropertyDetailsPage = require('./PropertyDetailsPage.scss');var styles = _interopRequireWildcard(_PropertyDetailsPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var PropertyDetailsPage = function (_Component) {_inherits(PropertyDetailsPage, _Component);function PropertyDetailsPage(props) {_classCallCheck(this, PropertyDetailsPage);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.












































    setUpFavoritesAnalytics = function (id) {
      var isFavorite = _this.props.favoriteProperties.indexOf(id) !== -1;
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.favorites,
      isFavorite ? _analyticsConstants.eventAction.remove : _analyticsConstants.eventAction.add,
      _analyticsConstants.eventLabel.propertyDetailsPage);
    };_this.





    toggleFavorite = function () {var
      data = _this.props.propertyDetails.data;

      // analytics
      _this.setUpFavoritesAnalytics(data.id);

      if (data) {
        _this.props.toggleFavorite({ property: data, token: _this.props.userToken });
      }
    };_this.

    handleEdit = function () {
      var id = (0, _get3.default)(_this.props, 'propertyDetails.propertyId');var _get =
      (0, _get3.default)(_this.props, 'propertyDetails.data.address'),country_name = _get.en.country_name;
      _this.props.editProperty(id);
      setTimeout(function () {
        if (country_name.indexOf('Israel') !== -1) {
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/property/edit?id=' + id));
        } else {
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign_property/edit?id=' + id));
        }
      });
    };_this.

    addPropertyNote = function (note) {var
      id = _this.props.propertyDetails.data.id;var
      token = _this.props.userToken;
      // analytics
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.notes, _analyticsConstants.eventAction.add, _analyticsConstants.eventLabel.propertyDetailsModal);
      _this.props.addPropertyNote({ noteData: { id: id, note: note }, token: token });
    };_this.

    fetchPropertyNote = function () {var _ref =
      _this.props.propertyDetails.data ? _this.props.propertyDetails.data : {},id = _ref.id;
      return (0, _fetchPropertyNoteById2.default)(id, _this.props.propertyNotes);
    };_this.state = { propertyType: props.propertyDetails.data ? _this.formatPropertyTypes(props.propertyDetails.data.property_type) : '' };return _this;}PropertyDetailsPage.prototype.componentWillMount = function componentWillMount() {if (!this.props.propertyDetails.data) {this.props.receiveProperty({ id: this.props.params.id, target: 'properties' });this.props.getSimilarProperties({ property_id: this.props.params.id });}this.props.setPinAsReviewed(this.props.params.id);};PropertyDetailsPage.prototype.componentDidMount = function componentDidMount() {window.document.body.classList.add('overflow'); // AdSense setup
    if (window && !window.__adsense_initialised__) {try {(window.adsbygoogle = window.adsbygoogle || []).push({ google_ad_client: _constants.googleAdClient, enable_page_level_ads: true });window.__adsense_initialised__ = !!window.adsbygoogle;} catch (e) {console.error(e);}} // hermione event
    _services.AnalyticsEventService.createPropertyEvent({ propertyId: this.props.params.id, action: _constants.analyticsEventAction.VIEW });};PropertyDetailsPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {var propertyDetails = _ref2.propertyDetails,locale = _ref2.locale;if ((!this.state.propertyType, propertyDetails.data) || propertyDetails && propertyDetails.data && this.state.locale !== locale) {this.setState({ propertyType: this.formatPropertyTypes(propertyDetails.data.property_type) });}};PropertyDetailsPage.prototype.componentWillUnmount = function componentWillUnmount() {window.document.body.classList.remove('overflow');};PropertyDetailsPage.prototype.formatPropertyTypes = function formatPropertyTypes(propertyType) {return this.props.translate('propertyTypes', propertyType)();};PropertyDetailsPage.prototype.render = function render() {var _props =








    this.props,_props$propertyDetail = _props.propertyDetails,isLightboxOpen = _props$propertyDetail.isLightboxOpen,currentImage = _props$propertyDetail.currentImage,isModalContactsOpen = _props$propertyDetail.isModalContactsOpen,isModalShareOpen = _props.isModalShareOpen,isNative = _props.isNative;

    var data = (0, _get3.default)(this.props, 'propertyDetails.data');

    if (!data && !this.props.propertyDetails.error) {
      return (
        _react2.default.createElement(_components.PropertyDetailsPlaceholder, {
          isMobile: this.props.isMobile,
          isRtl: this.props.isRtl,
          data: this.props.propertyDetails.preloadData || {},
          translate: this.props.translate('propertyDetails') }));


    }var _props2 =

    this.props,route = _props2.route,locale = _props2.locale;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    // if (!data && this.props.propertyDetails.loading) {
    //   return (
    //     <div className={styles.preloader}><img alt="preloader" src="/preloader.gif" /></div>
    //   );
    // }
    if (!data && this.props.propertyDetails.error) {var
      status = this.props.propertyDetails.error.status;
      if (status === 404 || status === 400) {
        return (
          _react2.default.createElement('div', null,
            _react2.default.createElement(_pages.NotFoundPage, {
              locale: this.props.locale,
              translate: this.props.translate,
              rootTranslate: this.props.translate,
              isMobile: this.props.isMobile })));



      }
    }

    var userData = (0, _get3.default)(this.props, 'userAuthentication.data', {});
    var title = (0, _formatSEOData.formatPropertyTitle)(
    this.props.propertyDetails.data,
    this.state.propertyType,
    this.props.translate('propertyDetails'),
    this.props.locale);

    var isFavorite = this.props.favoriteProperties.indexOf(data.id) !== -1;
    var descriptionData = {
      translatedDescriptionRequired: this.props.propertyDetails.translatedDescriptionRequired,
      translatedDescriptionText: this.props.propertyDetails.translatedDescriptionText,
      showOriginalDescription: this.props.propertyDetails.showOriginalDescription,
      descriptionLoaded: this.props.propertyDetails.descriptionLoaded,
      descriptionLoading: this.props.propertyDetails.descriptionLoading };


    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.translate('title', 'titleTemplate')(),
          title: title,
          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]),

          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route },
          { name: 'robots', content: 'noindex,nofollow' }] }),


        _react2.default.createElement(_components.PropertyDetails, {
          className: 'pageDetails detailsPage',
          isNative: isNative,
          propertyData: Object.assign({},
          data, {
            property_type: this.state.propertyType }),

          similarProperties: this.props.similarProperties,
          enPropertyType: this.props.propertyDetails.data.property_type,
          changeLightboxActiveSlide: this.props.changeLightboxActiveSlide,
          isModal: false,
          translate: this.props.translate,
          locale: this.props.locale,
          currentImage: currentImage,
          openLightbox: this.props.openLightbox,
          hideLightbox: this.props.hideLightbox,
          isLightboxOpen: isLightboxOpen,
          isMobile: this.props.isMobile,
          userData: userData,
          handleEdit: this.handleEdit,
          openModalContacts: this.props.openModalContacts,
          hideModalContacts: this.props.hideModalContacts,
          isModalContactsOpen: isModalContactsOpen,
          openModalShare: this.props.openModalShare,
          hideModalShare: this.props.hideModalShare,
          isModalShareOpen: isModalShareOpen,
          screenWidth: this.props.screenWidth,
          addPropertyNote: this.addPropertyNote,
          propertyNote: this.fetchPropertyNote(),
          isFavorite: isFavorite,
          toggleFavorite: this.toggleFavorite,
          translateDescription: this.props.translateDescription,
          toggleDescriptionTranslation: this.props.toggleDescriptionTranslation,
          descriptionData: descriptionData,
          detectDescriptionLanguage: this.props.detectDescriptionLanguage,
          resetDescriptionTranslate: this.props.resetDescriptionTranslate,
          isRtl: this.props.isRtl,
          incrementClicks: _services.AnalyticsEventService.createPropertyEvent })));



  };return PropertyDetailsPage;}(_react.Component);


PropertyDetailsPage.propTypes = {
  routeData: _propTypes2.default.object.isRequired,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  propertyDetails: _propTypes2.default.object,
  receiveProperty: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  params: _propTypes2.default.object,
  openModalContacts: _propTypes2.default.func,
  hideModalContacts: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  hideModalShare: _propTypes2.default.func,
  favoriteProperties: _propTypes2.default.array,
  propertyNotes: _propTypes2.default.array,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  screenWidth: _propTypes2.default.number,
  userToken: _propTypes2.default.string,
  route: _propTypes2.default.any,
  location: _propTypes2.default.object.isRequired,
  userAuthentication: _propTypes2.default.object,
  editProperty: _propTypes2.default.func,
  translateDescription: _propTypes2.default.func,
  toggleDescriptionTranslation: _propTypes2.default.func,
  detectDescriptionLanguage: _propTypes2.default.func.isRequired,
  resetDescriptionTranslate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  setPinAsReviewed: _propTypes2.default.func,
  isModalShareOpen: _propTypes2.default.bool,
  similarProperties: _propTypes2.default.object,
  getSimilarProperties: _propTypes2.default.func,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref3) {var
  lang = _ref3.lang,
  propertyDetails = _ref3.propertyDetails,
  favoriteProperties = _ref3.favoriteProperties,
  propertyNotes = _ref3.propertyNotes,
  windowDimentions = _ref3.windowDimentions,
  userAuthentication = _ref3.userAuthentication,
  native = _ref3.native,
  shareModal = _ref3.shareModal;return (
    {
      translate: (0, _reduxPagan.getLang)(lang, 'static'),
      propertyDetails: propertyDetails,
      propertyNotes: propertyNotes.data,
      isNative: native.isNative,
      favoriteProperties: favoriteProperties.favoriteIDs,
      screenWidth: windowDimentions.width,
      similarProperties: propertyDetails.similarProperties,
      userAuthentication: userAuthentication,
      userToken: userAuthentication.data ? userAuthentication.data.access_token : null,
      isModalShareOpen: shareModal.isModalShareOpen });};


var mapDispatchToProps = {
  openLightbox: _propertyDetails.openLightbox,
  hideLightbox: _propertyDetails.hideLightbox,
  changeLightboxActiveSlide: _propertyDetails.changeLightboxActiveSlide,
  receiveProperty: _propertyDetails.receiveProperty,
  openModalContacts: _propertyDetails.openModalContacts,
  hideModalContacts: _propertyDetails.hideModalContacts,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  openModalShare: _shareModal.openModalShare,
  hideModalShare: _shareModal.hideModalShare,
  addPropertyNote: _propertyNotes.addPropertyNote,
  translateDescription: _propertyDetails.translateDescription,
  editProperty: _manageProperties.editProperty,
  toggleDescriptionTranslation: _propertyDetails.toggleDescriptionTranslation,
  detectDescriptionLanguage: _propertyDetails.detectDescriptionLanguage,
  resetDescriptionTranslate: _propertyDetails.resetDescriptionTranslate,
  setPinAsReviewed: _reviewedPins.setPinAsReviewed,
  getSimilarProperties: _propertyDetails.getSimilarProperties };exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)([
{
  key: 'propertyDetails',
  promise: function promise(_ref4) {var params = _ref4.params,store = _ref4.store;return (
      store.dispatch(
      (0, _propertyDetails.receiveProperty)({ id: params.id, target: 'properties' })));} },


{
  key: 'similarProperties',
  promise: function promise(_ref5) {var params = _ref5.params,store = _ref5.store;return (
      store.dispatch((0, _propertyDetails.getSimilarProperties)({ property_id: params.id })));} }]),


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
PropertyDetailsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/PropertyDetailsPage/PropertyDetailsPage.js
// module id = 3101
// module chunks = 0